// Subscription styles
export const subscriptionStyles = {
    pricingTab: {
        borderRadius: '16px 0 0 16px',
        color: '#191C1B',
        textTransform: 'none',
        border: '1px solid #191C1B',
        borderRight: '0.5px solid #191C1B',
    },
    pricingButton: {
        boxShadow: 'none',
        margin: '0 0 1rem',
        borderRadius: '100px',
        textTransform: 'none',
        backgroundColor: '#61DBB7',
        color: '#FFFFFF',
    },
};
